import cn from 'clsx';
import { Dialog } from '@base-ui/react/dialog';

import { useChatbotSession } from '../../providers/ChatbotProvider';
import AssistantIcon from '../../assets/Assistant.svg';

import styles from './ChatbotLauncher.module.css';

type ChatbotLauncherProps = {
  open: boolean;
  className?: string;
};

export const ChatbotLauncher = ({ open, className }: ChatbotLauncherProps) => {
  const { t } = useChatbotSession();

  return (
    <Dialog.Trigger className={cn(styles.launcher, className)} aria-label={t('chatbot.open')} data-testid="chatbot-launcher" hidden={open}>
      <AssistantIcon aria-hidden="true" />
    </Dialog.Trigger>
  );
};
